module.exports = __webpack_public_path__ + "img/EShoplogo.fba7e454.svg";